import { z } from 'zod';
import { ReportingShellContextLoaderProps } from './reportingContextProps';

export const ReportingShellContextUrlParamsSchema = z
    .object({})
    .transform((item): ReportingShellContextLoaderProps => ({}));
